{
  "name": "@ns/data-select-record",
  "version": "1.2.0",
  "authorable": true,
  "description": "Pick one record from a data set, seeing only the fields the workflow maps, while the job is open. A second set it covers is what its reference fields pick from.",
  "inputs": {
    "SET": {
      "type": "string",
      "ref": "dataSet",
      "access": "READ"
    },
    "FIELDS": {
      "type": "array",
      "fieldsOf": "SET"
    },
    "LINKED_SET": {
      "type": "string",
      "ref": "dataSet",
      "access": "READ",
      "optional": true,
      "linked": true
    },
    "LINKED_FIELDS": {
      "type": "array",
      "fieldsOf": "LINKED_SET",
      "optional": true
    },
    "PROMPT": {
      "type": "string",
      "optional": true
    }
  },
  "outcomes": {
    "selected": {
      "inputs": {
        "RECORD": {
          "type": "string",
          "ref": "dataRecord"
        }
      }
    }
  }
}
